export * from './vds-paginator.component';